import {cachedJsonParse, getPenguinsData} from './helpers';
import clone from 'lodash/clone';

function restTextToJson(res) {
  return res.text().then(text => {
    try {
      const data = cachedJsonParse(text);
      return {
        data,
        status: res.status
      };
    } catch (err) {
      console.log(err);
      console.log(res);
      return {
        data: text,
        status: res.status
      };
    }
  });
}


function toReject(data) {
  return Promise.reject(data);
}

export function resToJson(res) {
  if (!res.ok) {
    return restTextToJson(res)
      .then(toReject)
      .catch(toReject);
  }
  return restTextToJson(res);
}

export function getCsrfHeader() {
  return {'X-CSRFToken': getPenguinsData(['csrf_token'])};
}

export function fetchFormData(url, params) {
  const body  = new FormData();

  // Push our data into our FormData object
  for(name in params) {
    body.append(name, params[name]);
  }

  return fetch(url, {
    method: 'POST',
    body
  });
}
